/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event__content[_ngcontent-%COMP%]{font-size:.789em;color:#626767;line-height:1.36;white-space:pre-wrap}.event__header[_ngcontent-%COMP%]{font-weight:700}"];
export { styles as styles };
